var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 28H19C18.7 28 18.5 27.8 18.5 27.5C18.5 27.2 18.7 27 19 27H21C24 27 26.5 24.5 26.5 21.5V20.5C26.5 20.2 26.7 20 27 20C27.3 20 27.5 20.2 27.5 20.5V21.5C27.5 25.1 24.6 28 21 28Z",
    fill: "#004463"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 27.5C19.5 28.1 19.1 28.5 18.5 28.5H17.5C16.9 28.5 16.5 28.1 16.5 27.5C16.5 26.9 16.9 26.5 17.5 26.5H18.5C19.1 26.5 19.5 26.9 19.5 27.5Z",
    fill: "#607D95"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16C25.7 16 25.5 15.8 25.5 15.5V12.5C25.5 12.2 25.7 12 26 12C26.3 12 26.5 12.2 26.5 12.5V15.5C26.5 15.8 26.3 16 26 16ZM5 16C4.7 16 4.5 15.8 4.5 15.5V12.5C4.5 12.2 4.7 12 5 12C5.3 12 5.5 12.2 5.5 12.5V15.5C5.5 15.8 5.3 16 5 16Z",
    fill: "#004463"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15.5H27C27.6 15.5 28 15.9 28 16.5V20.5C28 21.1 27.6 21.5 27 21.5H25V15.5Z",
    fill: "#607D95"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8997 13C26.4997 13 26.9997 12.5 26.8997 11.9C26.3997 6.1 21.4997 1.5 15.4997 1.5C9.49972 1.5 4.59972 6.1 4.09972 11.9C3.99972 12.5 4.49972 13 5.09972 13C5.59972 13 5.99972 12.6 6.09972 12.1C6.49972 7.3 10.5997 3.5 15.5997 3.5C20.5997 3.5 24.5997 7.3 25.0997 12.1C24.9997 12.6 25.3997 13 25.8997 13Z",
    fill: "#01A6FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09972 11.9C6.59972 6.4 10.9997 2 16.4997 1.5H15.4997C9.49972 1.5 4.59972 6.1 4.09972 11.9C3.99972 12.5 4.49972 13 5.09972 13C5.59972 13 5.99972 12.6 6.09972 12.1C5.99972 12.1 6.09972 12 6.09972 11.9ZM17.4997 3.5C17.1997 3.5 16.7997 3.5 16.4997 3.6C20.9997 4.1 24.4997 7.7 24.9997 12.2C24.9997 12.7 25.4997 13.1 25.9997 13.1C26.5997 13.1 26.9997 12.6 26.9997 12.1C26.3997 7.2 22.3997 3.5 17.4997 3.5Z",
    fill: "#006EF4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19 18.5H12C11.4 18.5 11 18.9 11 19.5V23.5C11 24.1 11.4 24.5 12 24.5H13V26.5L16 24.5H19C19.6 24.5 20 24.1 20 23.5V19.5C20 18.9 19.6 18.5 19 18.5Z",
    fill: "#EEF2FA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 25.2V24.5H14C13.4 24.5 13 24.1 13 23.5V19.5C13 18.9 13.4 18.5 14 18.5H12C11.4 18.5 11 18.9 11 19.5V23.5C11 24.1 11.4 24.5 12 24.5H13V26.5L15 25.2Z",
    fill: "#D5E5F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7 22.5C6.4 22.5 6 22.1 6 21.5V15.5C6 14.9 6.4 14.5 7 14.5C7.6 14.5 8 14.9 8 15.5V21.5C8 22.1 7.6 22.5 7 22.5ZM24 14.5C24.6 14.5 25 14.9 25 15.5V21.5C25 22.1 24.6 22.5 24 22.5C23.4 22.5 23 22.1 23 21.5V15.5C23 14.9 23.4 14.5 24 14.5Z",
    fill: "#4B6C85"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7 20.5C6.4 20.5 6 20.1 6 19.5V21.5C6 22.1 6.4 22.5 7 22.5C7.6 22.5 8 22.1 8 21.5V19.5C8 20.1 7.6 20.5 7 20.5ZM24 20.5C23.4 20.5 23 20.1 23 19.5V21.5C23 22.1 23.4 22.5 24 22.5C24.6 22.5 25 22.1 25 21.5V19.5C25 20.1 24.6 20.5 24 20.5Z",
    fill: "#40657C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6 21.5H4C3.4 21.5 3 21.1 3 20.5V16.5C3 15.9 3.4 15.5 4 15.5H6V21.5Z",
    fill: "#607D95"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15.5V19C4.5 19.6 4.1 20 3.5 20H3V20.5C3 21.1 3.4 21.5 4 21.5H6V15.5H4.5ZM26.5 15.5V19C26.5 19.6 26.9 20 27.5 20H28V20.5C28 21.1 27.6 21.5 27 21.5H25V15.5H26.5Z",
    fill: "#4B6C85"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1004 21H12.9004C12.6004 21 12.4004 20.8 12.4004 20.5C12.4004 20.2 12.6004 20 12.9004 20H18.1004C18.4004 20 18.6004 20.2 18.6004 20.5C18.6004 20.8 18.4004 21 18.1004 21ZM16.1004 23H12.9004C12.6004 23 12.4004 22.8 12.4004 22.5C12.4004 22.2 12.6004 22 12.9004 22H16.1004C16.4004 22 16.6004 22.2 16.6004 22.5C16.6004 22.8 16.4004 23 16.1004 23Z",
    fill: "#99B5CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.ba2a062d74d2c65ed74153f44d756485.svg";
export { ForwardRef as ReactComponent };